var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 21",
    width: 25,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M0.6 8.01C0.6 3.59 4.19 0 8.61 0L16.63 0L16.63 8.01C16.63 8.01 16.63 8.01 16.63 8.01C16.63 12.44 13.04 16.03 8.61 16.03L7.93 16.03C5.8 16.03 3.76 16.87 2.26 18.38L0.6 20.04L0.6 8.01ZM18.98 13.68C20.48 15.18 22.52 16.03 24.64 16.03L24.64 0C22.52 0 20.48 0.84 18.98 2.35C17.47 3.85 16.63 5.89 16.63 8.01C16.63 8.01 16.63 8.01 16.63 8.01C16.63 10.14 17.47 12.18 18.98 13.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4.8C4 4.36 4.34 4 4.75 4L11.5 4C11.91 4 12.25 4.36 12.25 4.8C12.25 5.24 11.91 5.6 11.5 5.6L4.75 5.6C4.34 5.6 4 5.24 4 4.8ZM4 8C4 7.56 4.34 7.2 4.75 7.2L13.25 7.2C13.66 7.2 14 7.56 14 8C14 8.44 13.66 8.8 13.25 8.8L4.75 8.8C4.34 8.8 4 8.44 4 8ZM9.75 10.4C10.16 10.4 10.5 10.76 10.5 11.2C10.5 11.64 10.16 12 9.75 12L4.75 12C4.34 12 4 11.64 4 11.2C4 10.76 4.34 10.4 4.75 10.4L9.75 10.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChat);
export default __webpack_public_path__ + "static/media/video-chat.73268d890ec97baab6fd466b8da216e1.svg";
export { ForwardRef as ReactComponent };